import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { LazyLoadEvent } from "../../models/DataTables/lazyLoadEvent";
import { AuthenticationService } from "../authentication/authentication.service";
import { LoggingService } from "../logging/logging.service";
import { InvoiceTheme, InvoiceThemeResponse } from '../../models/inModels/InvoiceTheme';

@Injectable()
export class InvoiceThemeService {
	private route = '/api/invoice/theme';
	constructor(
		private http: HttpClient,
		private auth: AuthenticationService,
		private logging: LoggingService) { }

	search(event: LazyLoadEvent): Promise<any> {
		return this.http.post(`${this.auth.apiUrl}${this.route}/search`, event, { headers: this.auth.header })
			.toPromise()
			.then(response => response)
			.catch(error => this.logging.handleError(error));
	}

	get(id: number): Promise<InvoiceThemeResponse> {
		return this.http.get(`${this.auth.apiUrl}${this.route}/get/${id}`, { headers: this.auth.header })
			.toPromise()
			.then(response => response as InvoiceThemeResponse)
			.catch(error => this.logging.handleError(error));
	}

	create(coupon: InvoiceTheme): Promise<InvoiceThemeResponse> {
		return this.http.post(`${this.auth.apiUrl}${this.route}/create`, coupon, { headers: this.auth.header })
			.toPromise()
			.then(response => response as InvoiceThemeResponse)
			.catch(error => this.logging.handleError(error));
	}

	update(coupon: InvoiceTheme): Promise<InvoiceThemeResponse> {
		return this.http.post(`${this.auth.apiUrl}${this.route}/update`, coupon, { headers: this.auth.header })
			.toPromise()
			.then(response => response as InvoiceThemeResponse)
			.catch(error => this.logging.handleError(error));
	}

	delete(id: string): Promise<any> {
		return this.http.delete(`${this.auth.apiUrl}${this.route}/delete/${id}`, { headers: this.auth.header })
			.toPromise()
			.then(response => response)
			.catch(error => this.logging.handleError(error));
	}
}



// WEBPACK FOOTER //
// ./src/app/services/invoice-theme/invoice-theme.service.ts